<template>
    <div class="block-button-text">
        <div class="block-button-text__inner">
            <component 
                :is="link ? 'UtilRouteLink' : 'button'"
                :link="link"
                @click="action ? action() : null"
            >
                <AtomButton
                    :text="text"
                    html-tag="div"
                />
            </component>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    text: {
        type: String,
        required: true,
    },
    link: {
        type: String,
        required: false,
    },
    action: {
        type: Function,
        required: false,
    },
});
</script>

<style lang="scss" scoped>
.block-button-text {
    @include wrapper-layout;
    @include grid-layout();

    margin-bottom: var(--m-bottom--medium);
}

.block-button-text__inner {
    @include default-content-columns('text');
}
</style>